
  import { Vue, Component, Prop } from "vue-property-decorator";

  import TabsWithRoutes from "@/components/common/TabsWithRoutesNew.vue";

  import LIST_COMPANIES from "@/apollo/company/ListCompanies.gql";

  import { User, Company } from "@/interface";
  import PostingSources from "@/entities/PostingSources";
  import RouteNames from "@/entities/RouteNames";
  import RouteTabs from "@/entities/RouteTabs";

  @Component({
    components: {
      TabsWithRoutes,
    },
    apollo: {
      companies: {
        query: LIST_COMPANIES,
        variables() {
          return { userId: this.currentUser.id };
        },
        update(data) {
          return data.contracted;
        },
      },
    },

  })
  export default class ContractorPostingsTabs extends Vue {
    @Prop({type: Object, required: true}) readonly currentUser!: User;

    companies?: Company[] = undefined;

    routeTabs: RouteTabs = {
      [RouteNames.JOBBOARD_POSTINGS_MARKETPLACE]: PostingSources.MARKETPLACE,
      [RouteNames.JOBBOARD_POSTINGS_INTERNAL]: PostingSources.COMPANIES,
    };
  }
